import React, { Component } from "react";
import { withLocalize } from "react-localize-redux";
import ContentLoader from "react-content-loader";
import translations from "../../translations/verify.json";

class RectLoader extends Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.props.addTranslation(translations);
	}
	componentWillReceiveProps(...args) {}
	componentDidMount() {
		// let viewBox = "0 0 " + string(this.props.v1) + " " + string(this.props.v2);
		// console.log(this.props);
	}

	render() {
		return (
			<ContentLoader viewBox={`0 0 ${this.props.width} ${this.props.height}`}>
				<rect
					x="0"
					y="0"
					rx={this.props.radius}
					ry={this.props.radius}
					width={this.props.width}
					height={this.props.height}
				/>
			</ContentLoader>
		);
	}
}

export default withLocalize(RectLoader);
